module.exports = __webpack_public_path__ + "img/stickman_family.3fa5029f.jpg";